import { useResponsiveValue as useResponsiveArray } from '@theme-ui/match-media';

export function useResponsiveValue<T>(value: T | T[]) {
  return useResponsiveArray(Array.isArray(value) ? value : [value]);
}

export { useBreakpointIndex } from '@theme-ui/match-media';
